import * as React from 'react';
import { Table } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import IPlanFirm from './IPlanFirm';
import PlanFirmListRow from './PlanFirmListRow';

interface IPlanFirmListProps {
    items: IPlanFirm[];
    beginEdit: (id: number) => void;
    delete: (id: number) => void;
}

const PlanFirmList = (props: IPlanFirmListProps) => {
    return (
        <Table responsive>
            <thead>
                <tr>
                    <th>{Translate('plan-firms/list/header/name')}</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {props.items
                    .sort((a: IPlanFirm, b: IPlanFirm) => {
                        if (a.name < b.name) {
                            return -1;
                        }
                        if (a.name > b.name) {
                            return 1;
                        }

                        return 0;
                    })
                    .map((item: IPlanFirm, i: number) => (
                        <PlanFirmListRow
                            key={`plan-firm-${i}`}
                            planFirm={item}
                            beginEdit={props.beginEdit}
                            delete={props.delete}
                        />
                    ))}
            </tbody>
        </Table>
    );
};

export default PlanFirmList;
